// ============================================================================
// CONFIG ENDPOINTS
// ============================================================================
// Backend: api/v1/Config (ConfigController.cs).

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';

const BASE_PATH = '/Config';

export const configEndpoints = {
  groups: () => buildEndpoint(`${BASE_PATH}/groups`),
  definitions: (group: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/definitions`, { group }),
  effective: (group: string, scopes?: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/effective`, { group, scopes }),
  effectiveByKey: (configKey: string, scopes?: string) =>
    scopes
      ? buildEndpointWithQuery(`${BASE_PATH}/effective/${configKey}`, { scopes })
      : buildEndpointWithParams(`${BASE_PATH}/effective/:configKey`, { configKey }),
  updateValues: () => buildEndpoint(`${BASE_PATH}/values`),
  scopes: (scopeType: string) =>
    buildEndpointWithQuery(`${BASE_PATH}/scopes`, { scopeType }),
  basePath: () => BASE_PATH,
} as const;

export default configEndpoints;
